import React, {Component} from 'react';
import Header from './components/header';
import Footer from './components/footer';
import routes from './config/routes.js';
import AppRoute from './components/approute';
//import axios from 'axios';

import {
//	BrowserRouter as Router,
	Switch  
  } from "react-router-dom";

let config = require('./config/data.json');


class App extends Component {      
      constructor(props) {
        super(props);

        this.state={
          user:{
            role:"",
            isLogged:false,
          }
        }        
      }
      
      callBack = (values) => {
          let user ={
            role:values.role,
            isLogged:values.islogged,
          }
          this.setState({user});          
      }
      
      render() {  
                        
        //console.log('routes: ', {routes});                          
        //console.log('config.categories: ', config.categories);
        //console.log('App this.state: ', this.state);

        return (
          
            <div className="page">
              <div className="catalog">
              <Header key="0" config={config} onCallBack={this.callBack} />
              <Switch>
                  {routes.map((route) => (
                    <AppRoute
                        exact={true}
                        key={route.path}
                        path={route.path}
                        config={config}                         
                        onCallBack={this.callBack}
                        component={route.component}
                        isPrivate={route.isPrivate}
                      />
                    ))}
              </Switch>

              <Footer />
              </div>
            </div>
            
        );
      }
}
export default App;

